export default [
    {
        path: '/calculator/property_income',
        name: 'Calculator-Property-Income',
        component: () => import('@/views/modules/calculator/property_income/_property_income.vue')
    },
    {
        path: '/calculator/mortgage_loan',
        name: 'Calculator-Mortgage-Loan',
        component: () => import('@/views/modules/calculator/mortgage_loan/_mortgage_loan.vue')
    },
    {
        path: '/calculator/mortgage_refinance',
        name: 'Calculator-Mortgage-Refinance',
        component: () => import('@/views/modules/calculator/mortgage_refinance/_mortgage_refinance.vue')
    },
]